import React from "react";
import "flag-icon-css/css/flag-icons.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingCart from "./components/FloatingCart";
// import AdPopup from "./components/AdPopup";
import ScrollToTop from "./components/ScrollToTop";

import HomePage from "./pages/HomePage";
import Reservations from "./pages/Reservations";
import ContactPage from "./pages/ContactPage";
import ThankYouPage from "./pages/ThankYouPage";
import OrderTracking from "./pages/OrderTracking";
import MenuPage from "./pages/MenuPage";
import CheckoutPage from "./pages/CheckoutPage";
import EasterBuffet from "./pages/EasterBuffet";
import OrderSuccessRedirect from "./pages/OrderSuccessRedirect";
import DrinksPage from "./pages/DrinksPage";
import SuccessPage from "./pages/SuccessPage";

import { CartProvider } from "./context/CartContext";
import { ToastProvider } from "./context/ToastContext";
import { CheckoutProvider } from "./context/CheckoutContext";
import { StoreClosureProvider } from "./context/StoreClosureContext";
import { HelmetProvider } from "react-helmet-async";

function AppLayout() {
  // const location = useLocation();

  // routes where ads should NOT appear
  // const hideAds =
  //   location.pathname === "/easter-buffet" ||
  //   location.pathname === "/success" ||
  //   location.pathname === "/order-success" ||
  //   location.pathname === "/checkout";

  return (
    <>
      <ScrollToTop />
      <Navbar />

      {/* {!hideAds && <AdPopup />} */}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/reservations" element={<Reservations />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/order-tracking" element={<OrderTracking />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-success" element={<OrderSuccessRedirect />} />
        <Route path="/drinks" element={<DrinksPage />} />
        <Route path="/easter-buffet" element={<EasterBuffet />} />
        <Route path="/success" element={<SuccessPage />} />
      </Routes>

      <Footer />
      <FloatingCart />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <StoreClosureProvider>
        <CheckoutProvider>
          <ToastProvider>
            <CartProvider>
              <Router>
                <AppLayout />
              </Router>
            </CartProvider>
          </ToastProvider>
        </CheckoutProvider>
      </StoreClosureProvider>
    </HelmetProvider>
  );
}

export default App;